import { inject, InjectionKey } from 'vue';
import { ExchangeApiService } from './exchangeApiService';

export const EXCHANGE_API_KEY: InjectionKey<ExchangeApiService> = Symbol('ExchangeApiService');

export function useExchangeApi(): ExchangeApiService {
	const service = inject<ExchangeApiService>(EXCHANGE_API_KEY);
	if (!service) throw new Error('ExchangeApiService not provided');
	return service;
}
